<template>
  <div class="content">
    <div class="cont-list">
      <span class="list">{{
        this.parentRoute.menuName + "-" + this.route.menuName
      }}</span>
      <!-- <span class="masge">当前共有{{ total }}个模块</span> -->
    </div>

    <div class="content-card" ref="cardContent">
      <card :tableAcl="tableAcl" :type="0" :title="'国家'" :dataList="countryData" @filterMethod="handleCountrySearch" @getChildrenData="getChildrenData" @handleAdd="handleAdd" @handleDelete="handleDelete" @handleUpdate="handleUpdate" />
      <card :tableAcl="tableAcl" :type="1" :title="'省/直辖市/州'" :dataList="provinceData" @filterMethod="handleProvinceSearch" @getChildrenData="getChildrenData" @handleAdd="handleAdd" @handleDelete="handleDelete" @handleUpdate="handleUpdate"></card>
      <card :tableAcl="tableAcl" :type="2" :title="'城市'" :dataList="cityData" :isLast="true" @filterMethod="handleCitySearch" @handleAdd="handleAdd" @handleDelete="handleDelete" @handleUpdate="handleUpdate"></card>
    </div>

    <el-dialog :title="title" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" @change="nameChange" placeholder="请填写名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="缩写" prop="abbreviation">
              <el-input v-model="form.abbreviation"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <my-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</my-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetFactoryInfos, SaveFactoryInfo, RemoveFactoryInfos } from "@/api";
import Card from "@/components/card";
import { makePy } from "@/utils/pinyin";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  components: {
    Card,
  },
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      countryQuery: {
        keyWord: "",
        pageSize: 1000,
        pageIndex: 1,
        type: 0,
      },
      provinceQuery: {
        keyWord: "",
        pageSize: 1000,
        pageIndex: 1,
        type: 0,
      },
      cityQuery: {
        keyWord: "",
        pageSize: 1000,
        pageIndex: 1,
        type: 0,
      },
      // 列表数据
      countryData: [],
      provinceData: [],
      cityData: [],
      // 列表总数
      // total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // // 新增启用开关
      // iso: true,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
      countryActive: null,
      provinceActive: null,
      rules: {
        path: [{ required: true, message: "请输入路由", trigger: "blur" }],
        name: [{ required: true, message: "请选择名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    getCountryData () {
      GetFactoryInfos(this.countryQuery).then((res) => {
        this.countryData = res.returnData.data;
      });
    },
    getProvinceData () {
      GetFactoryInfos(this.provinceQuery).then((res) => {
        this.provinceData = res.returnData.data;
      });
    },
    getCityData () {
      GetFactoryInfos(this.cityQuery).then((res) => {
        this.cityData = res.returnData.data;
      });
    },
    getChildrenData (id, type) {
      if (type == 0) {
        this.countryActive = id;
        this.provinceActive = null;
        this.provinceQuery.type = type + 1;
        this.provinceQuery.parentId = id;
        this.getProvinceData();

        this.cityData = [];
      } else {
        this.provinceActive = id;
        this.cityQuery.type = type + 1;
        this.cityQuery.parentId = id;
        this.getCityData();
      }
    },
    handleCountrySearch (keyWord, type) {
      this.countryQuery.type = type;
      this.countryQuery.keyWord = keyWord;
      this.getCountryData();

      this.countryActive = null;
      this.provinceActive = null;
      this.provinceData = [];
      this.cityData = [];
    },
    handleProvinceSearch (keyWord, type) {
      this.provinceQuery.type = type;
      this.provinceQuery.keyWord = keyWord;
      this.getProvinceData();

      this.provinceActive = null;
      this.cityData = [];
    },
    handleCitySearch (keyWord, type) {
      this.cityQuery.type = type;
      this.cityQuery.keyWord = keyWord;
      this.getCityData();
    },
    // 新建
    handleAdd (type) {
      if (type == 1 && !this.countryActive) {
        this.$my_message(`请先选择一个国家`, "warning");
        return;
      } else if (type == 2 && !this.provinceActive) {
        this.$my_message(`请先选择一个省/直辖市/州`, "warning");
        return;
      }
      this.open = true;
      this.title = "新建" + this.getName(type);
      this.resetForm(type);

      if (type == 1) {
        this.form.parentId = this.countryActive;
      } else if (type == 2) {
        this.form.parentId = this.provinceActive;
      }
    },
    getName (type) {
      let name = "国家";
      if (type == 1) {
        name = "省/直辖市/州";
      } else if (type == 2) {
        name = "城市";
      }
      return name;
    },
    // 编辑
    handleUpdate (row) {
      console.log(row);
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑" + this.getName(row.type);
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveFactoryInfo(this.form).then((res) => {
          this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData(this.form.type);
        });
      });
    },
    getData (type) {
      if (type == 0) {
        this.getCountryData();
      } else if (type == 1) {
        this.getProvinceData();
      } else if (type == 2) {
        this.getCityData();
      }
    },
    resetForm (type) {
      this.form = {
        name: "",
        abbreviation: "",
        type,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.open = false;
        })
        .catch(() => { });
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveFactoryInfos({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData(row.type);
        })
        .catch(() => { });
    },
    nameChange (val) {
      let pinyin = "";
      if (val) {
        pinyin = makePy(val);
      }
      this.form.abbreviation = pinyin;
    },
  },
  mounted () {
    this.getCountryData();
    // this.getModules('')
    this.$refs.cardContent.style.setProperty(
      "height",
      this.$refs.cardContent.parentElement.clientHeight -
      this.$refs.cardContent.offsetTop +
      this.$refs.cardContent.parentElement.offsetTop -
      50 +
      "px"
    );
  },
};
</script>

<style lang="scss" scoped>
// .content-card {
//   // height: 748px;
// }
</style>
